import React, { useState } from "react";
import ContractContainer from "./ContractContainer";
import Page from "shared/components/Page";
import { CustomDropDown, CustomInput } from "shared/components/allInput";
import { Divider } from "primereact/divider";
import { Avatar } from "primereact/avatar";
import CustomButton from "shared/components/inputButton";
import { agreementsList } from "shared/components/AllDropdownOptions";
import constants from "constants";
import SignatureModal from "pages/Views/commonComponents/DigitalSign";
import Terms from "pages/Views/commonComponents/Terms/Terms";
import ContractListing from "pages/Views/commonComponents/ContractListing";
import Document from "pages/Views/commonComponents/Document/Document";
import { useNavigate, useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import ReactQuill from "react-quill";

const ContractForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data,
    setData,
    producerData,
    setProducerData,
    sideArtistData,
    setSideArtistData,
    publishingData,
    setPublishingData,
    musicVideoData,
    setMusicVideoData,
    artworkData,
    setArtworkData,
    remixData,
    setRemixData,
    handleChange,
    projectsList,
    profile,
    setActiveIndex,
    activeIndex,
    onTermsSubmit,
    onDocumentSubmit,
    onSignSubmit,
    loading,
    signatureModalVisible,
    setSignatureModalVisible,
    typedSignature,
    setTypedSignature,
    drawnSignature,
    setDrawnSignature,
    handleSaveSignature,
    sign,
    setSign,
    contractData,
    setContractData,
    shareDialog,
    setShareDialog,
    emails,
    setEmails,
    showAdditionalEmail,
    setShowAdditionalEmail,
    addEmailField,
    removeEmailField,
    handleEmailChange,
    handleClear,
    currentSigner,
    handleShareContract,
    setCurrentSigner,
    shareLoading,
    setShareLoading,
    agreements,
    setAgreements,
    quillRef,
    htmlContent,
    setHtmlContent,
    modules,
    formats,
    contractStatus,
    onSideArtistSubmit,
    onArtworkSubmit
  } = ContractContainer();

  return (
    <div className="">
      {activeIndex === 0 ? (
        <>
          <Page
            title="Contract Generator"
            description={
              <>
                <div className="flex justify-content-between md:flex-row flex-column">
                  <div className="flex gap-0 mb-2 md:gap-4 flex-wrap align-items-center md:w-6">
                    <div className="">Project </div>
                    <CustomDropDown
                      options={projectsList}
                      data={data}
                      onChange={handleChange}
                      optionLabel="name"
                      extraClassName="p-0"
                      inputClass="border-round-3xl md:w-15rem"
                      name="project"
                      ignoreLabel
                    />
                  </div>
                  <div className="flex gap-0 mb-2 md:gap-4 flex-wrap align-items-center md:w-6">
                    <div className="">Agreement</div>
                    <CustomDropDown
                      options={agreements}
                      data={data}
                      name="agreementType"
                      extraClassName="p-0"
                      onChange={handleChange}
                      inputClass="border-round-3xl md:w-15rem"
                      ignoreLabel
                      disabled={!data.project}
                    />
                  </div>
                </div>
              </>
            }
          />
          <div className="bg-main my-4 p-4">
            <h2 className="text-lg text-white">{data?.agreementType}</h2>
            <div className="grid mt-4">
              <div className="col-12 md:col-3">
                <p className="text-white">Date</p>
                <Divider />
                <p className="font-bold text-white">{data?.agreementDate}</p>
              </div>
              <div className="col-12 md:col-3">
                <p className="text-white">Owner</p>
                <Divider />
                <div className="flex align-items-center gap-3">
                  <Avatar
                    image={
                      profile?.image
                        ? `${constants.baseUrl}${profile.image}`
                        : null
                    }
                    shape="circle"
                  />
                  <p className="font-bold text-white m-0">
                    {profile?.fullName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}

      <div className="contract-review">
        <div className="flex w-full overflow-auto justify-content-between align-items-center sticky top-0 bg-white z-1 py-3">
          <div className="flex tab-buttons mb-2 gap-7 justify-content-end">
            <CustomButton
              onClick={() => setActiveIndex(0)}
              className={`bg-transparent border-none ${
                activeIndex === 0 ? "active" : ""
              }`}
              rounded
              outlined={activeIndex !== 0}
              label="Terms"
            />
            <CustomButton
              onClick={() => {
                setActiveIndex(1);
              }}
              className={`bg-transparent border-none ${
                activeIndex === 1 ? "active" : ""
              }`}
              rounded
              outlined={activeIndex !== 1}
              label="Document"
              disabled={!id}
            />
            <CustomButton
              onClick={() => {
                setActiveIndex(2);
              }}
              className={`bg-transparent border-none ${
                activeIndex === 2 ? "active" : ""
              }`}
              rounded
              outlined={activeIndex !== 2}
              label="Contract Listing"
            />
          </div>
          <div className="flex gap-3">
            {activeIndex === 0 ? (
              <CustomButton
                loading={loading}
                label={id ? "Update" : "Generate"}
                extraClass="w-auto border-round-3xl"
                onClick={onTermsSubmit}
              />
            ) : activeIndex === 1 ? (
              <>
                {(contractStatus === "AWAITING_SIGNING" ||
                  contractStatus === "IN_PROGRESS") && (
                  <CustomButton
                    loading={loading}
                    label="Save"
                    extraClass="w-auto border-round-3xl"
                    onClick={onDocumentSubmit}
                    disabled={!id}
                  />
                )}

                {contractStatus === "AWAITING_SHARE" && (
                  <CustomButton
                    loading={shareLoading}
                    label="Share"
                    extraClass="w-auto border-round-3xl"
                    icon="pi pi-share-alt"
                    onClick={() => setShareDialog(true)}
                    disabled={!id}
                  />
                )}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="mt-4 px-2">
          {activeIndex === 0 ? (
            <Terms
              data={data}
              setData={setData}
              producerData={producerData}
              setProducerData={setProducerData}
              sideArtistData={sideArtistData}
              setSideArtistData={setSideArtistData}
              publishingData={publishingData}
              setPublishingData={setPublishingData}
              musicVideoData={musicVideoData}
              setMusicVideoData={setMusicVideoData}
              artworkData={artworkData}
              setArtworkData={setArtworkData}
              remixData={remixData}
              setRemixData={setRemixData}
              contractData={contractData}
              onSideArtistSubmit={onSideArtistSubmit}
              onArtworkSubmit = {onArtworkSubmit}
            />
          ) : activeIndex === 1 ? (
            <Document
              sign={sign}
              data={data}
              setSign={setSign}
              onSignSubmit={onSignSubmit}
              handleClearSignature={handleClear}
              currentSigner={currentSigner}
              setCurrentSigner={setCurrentSigner}
              htmlContent={htmlContent}
              setHtmlContent={setHtmlContent}
              quillRef={quillRef}
              modules={modules}
              formats={formats}
            />
          ) : (
            navigate("/contracts")
          )}
        </div>
      </div>

      {/* Signature Modal */}
      <SignatureModal
        visible={signatureModalVisible}
        setVisible={setSignatureModalVisible}
        typedSignature={typedSignature}
        setTypedSignature={setTypedSignature}
        drawnSignature={drawnSignature}
        setDrawnSignature={setDrawnSignature}
        onSave={handleSaveSignature}
        currentSigner={currentSigner}
      />
      <Dialog
        header="Share Contract"
        visible={shareDialog}
        style={{ width: "50vw" }}
        onHide={() => setShareDialog(false)}
      >
        {/* First Email Field */}
        <CustomInput
          data={emails}
          name="email1"
          label="Email 1"
          onChange={handleEmailChange}
          extraClassName="w-full p-0 mb-2"
        />

        {/* Second Email Field (if added) */}
        {showAdditionalEmail && (
          <div className="flex align-items-end justify-content-between gap-3 mb-2">
            <CustomInput
              data={emails}
              name="email2"
              label="Email 2"
              onChange={handleEmailChange}
              extraClassName="w-9 p-0"
            />
            <CustomButton
              label="Remove"
              extraClassName="bg-red-600 mt-2"
              onClick={removeEmailField}
            />
          </div>
        )}

        {/* Show "Add Email" button only if no additional field is shown */}
        {!showAdditionalEmail && (
          <CustomButton label="Add Email" onClick={addEmailField} />
        )}

        <div className="flex gap-3 mt-3">
          <CustomButton label="Share Contract" onClick={handleShareContract} />
          <CustomButton
            label="Cancel"
            extraClassName="bg-black-alpha-90"
            onClick={() => setShareDialog(false)}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ContractForm;
